// removed by extract-text-webpack-plugin
module.exports = {"light-blue-bg":"light-blue-bg__3Bd6x","article-container":"article-container__yg40w","felxible-box":"felxible-box__1rkHP","felxible-small-box":"felxible-small-box__1h04X","article-box":"article-box__1okl_","article-txt":"article-txt__1tUtK","article-para":"article-para__3sVQX","article-link":"article-link__2sYOM"};


//////////////////
// WEBPACK FOOTER
// ./styles/elss/articles.scss
// module id = 1264
// module chunks = 68